<template>
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.375 3.5H9.625L9.62412 9.625H7.875V11.375H9.625V13.125H11.375V11.375H14.875V9.625H11.375V3.5Z"
      fill="currentColor" />
    <path
      d="M10.5 0C4.70138 0 0 4.70138 0 10.5C0 16.2986 4.70138 21 10.5 21C16.2986 21 21 16.2986 21 10.5C21 4.70138 16.2986 0 10.5 0ZM10.5 19.25C5.67525 19.25 1.75 15.3247 1.75 10.5C1.75 5.67525 5.67525 1.75 10.5 1.75C15.3247 1.75 19.25 5.67525 19.25 10.5C19.25 15.3247 15.3247 19.25 10.5 19.25Z"
      fill="currentColor" />
  </svg>
</template>
